<div class="status-badge" [class]="'status-badge--' + status.toLowerCase()">
  {{ label }}
</div>
